import { render, staticRenderFns } from "./Componente.vue?vue&type=template&id=193df7ea&scoped=true"
import script from "./Componente.vue?vue&type=script&lang=js"
export * from "./Componente.vue?vue&type=script&lang=js"
import style0 from "./Componente.vue?vue&type=style&index=0&id=193df7ea&prod&lang=css"
import style1 from "./Componente.vue?vue&type=style&index=1&id=193df7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193df7ea",
  null
  
)

export default component.exports